module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/devices/laptop-macbook-76f045cc366df0f108911ebf8bd54156.svg";